import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=23f29f29&scoped=true&"
import script from "./userAvatar.vue?vue&type=script&lang=ts&"
export * from "./userAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f29f29",
  null
  
)

export default component.exports